type TranslationFunction = (key: string) => string;

type RepairsOrMaintenanceOption = {
  value: string;
  label: string;
};

export const getRepairsOrMaintenanceList = (
  t: TranslationFunction,
  isWwAi: boolean,
): RepairsOrMaintenanceOption[] => {
  if (!isWwAi) {
    return [
      { value: 'yes', label: t('Yes') },
      { value: 'no_actions', label: t('No action is required.') },
    ];
  } else {
    return [
      { value: 'no_actions', label: t('No action is required.') },
      { value: 'maintenance', label: t('Maintenance was conducted on Waites equipment.') },
    ];
  }
};
